import React from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter } from 'react-router-dom';
import Home from "./Home";
import Map from "./Map";
import About from "./pages/About";
import Ourservices from "./pages/Ourservices";
import Investors from "./pages/Investors";
import RS11Foundation from "./pages/RS11Foundation";
import Careers from "./pages/Careers";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CopyRights from "./pages/CopyRights";
import AccountSettings from './pages/AccountSettings';
import AccountSettingsEdit from './pages/AccountSettingsEdit';
import '../../css/app.scss';
import Header from './reusable/Header';
import Footer from './reusable/Footer';
import Help from './pages/Help';
import Press from './pages/Press';
import ChangePassword from './Mobile/ChangePassword';
import LikedBusinesses from './pages/LikedBusinesses';
// import Apps from './pages/testSeconds';
// import TestPagination from './reusable/pagination';

function App() {
    return(
        <Router>
            <div>
                <Switch>
                        <Route exact path="/"><Home /></Route>
                </Switch>
            </div>
            <div>
                <Route render={({ location }) => (
                    location.pathname !== '/' && <Header />
                )} />
                <div>
                    <Switch>
                        <Route path="/map" render={(props) => <Map {...props}/>} />
                        <Route path="/about-us"> <About /></Route>
                        <Route path="/our-services"> <Ourservices /></Route>
                        <Route path="/investors"> <Investors /></Route>
                        <Route path="/rs11-foundation"> <RS11Foundation /></Route>
                        <Route path="/careers"> <Careers /></Route>
                        <Route path="/privacy-policy"> <PrivacyPolicy /></Route>
                        <Route path="/terms"> <TermsOfService /></Route>
                        <Route path="/copyright"> <CopyRights /></Route>
                        <Route path="/account-settings"><AccountSettings /></Route>
                        <Route path="/account-settings-edit"><AccountSettingsEdit /></Route>
                        <Route path="/help"><Help /></Route>
                        <Route path="/press"><Press /></Route>
                        <Route path="/change-password"><ChangePassword /></Route>
                        <Route path="/like"><LikedBusinesses /></Route>
                        {/* <Route path="/apps"><TestPagination /></Route> */}
                    </Switch>
                </div>
                <Route render={({ location }) => (
                    (location.pathname !== '/' && location.pathname !== '/map') && <Footer />
                )} />
            </div>
      </Router>
  )
}
export default App;

